import classNames from "classnames";
import { capitalize } from "../../../utils/StringUtilities";

export function toNodeProps({ element }) {
  // Preserve original HTML attributes within an elementAttributes key of the node
  const attributes = {};
  for (const attr of element.attributes) {
    switch (attr.name) {
      case "class":
        attributes["className"] = attr.value;
        break;
      case "style":
        attributes[attr.name] = attr.value
          .split(";")
          .filter((v) => v)
          .map((v) => v.trim())
          .reduce((acc, curr) => {
            const [key, value] = curr.split(/:(.*)/).map((v) => v.trim());
            // convert kebab case to camel case
            acc[
              key
                .split("-")
                .map((w, i) => {
                  return i > 0 ? capitalize(w) : w;
                })
                .join("")
            ] = value;
            return acc;
          }, {});
        break;
      default:
        attributes[attr.name] = attr.value;
    }
  }
  return { elementAttributes: attributes };
}

/*
Given Slate Node props, output all the JSX props to render the element. This should combine the original HTML attributes
parsed above with any new attributes added by Plate.
*/
export function withNodeProps(props) {
  if (props.element) {
    // node props should only applied to elements (not leafs)
    const jsx = props.attributes
      ? {
          ...props.attributes,
          className:
            classNames((props.attributes as any).className, props.className) ||
            undefined,
          style: { ...(props.attributes as any).style, ...props.style },
        }
      : {};
    for (let [k, v] of Object.entries(props.element.elementAttributes || {})) {
      switch (k) {
        case "className":
          jsx["className"] = classNames(v, jsx["className"]);
          break;
        case "style":
          jsx["style"] = {
            ...(v as object),
            ...jsx["style"], // new style props should take precedence
          };
          break;
        default:
          jsx[k] = v;
      }
    }
    return jsx;
  } else {
    return {};
  }
}
